export class Controller {

    /** @ngInject */
    constructor(Alert, EditProfileBasicModal) {
        this.Alert = Alert;
        this.EditProfileBasicModal = EditProfileBasicModal;
    }

    $onInit() {
    }

    isActiveDirectory() {
        return !!this.profile.adAccountClone;
    }

    isFacebook() {
        return this.profile.profileSource === 'FACEBOOK';
    }

    showEditProfileBasicModal() {
        this.EditProfileBasicModal(this.profile)
            .then(profile => {
                Object.assign(this.profile, profile);
                this.Alert('success', 'registration_profiles.messages.edit');
            });
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/user/profiles/profile/basic/basic.controller.js